<div class="ostso-filter-indicators">
  @if (filter) {
    @if (filter.group && !!filter.group.length) {
      <ostso-filter-indicator [count]="filter.group.length" label="Группа"/>
    }
    @if (filter.rateGroupIds && !!filter.rateGroupIds.length) {
      <ostso-filter-indicator [count]="filter.rateGroupIds.length" label="Группа"/>
    }
    @if (filter.subgroup && !!filter.subgroup.length) {
      <ostso-filter-indicator [count]="filter.subgroup.length" label="Подгруппа"/>
    }
    @if (filter.rateSubGroupIds && !!filter.rateSubGroupIds.length) {
      <ostso-filter-indicator [count]="filter.rateSubGroupIds.length" label="Подгруппа"/>
    }
    @if (!!filter.kind && !!filter.kind.length) {
      <ostso-filter-indicator [count]="filter.kind.length" label="Вид"/>
    }
    @if (!!filter.rateKindIds && !!filter.rateKindIds.length) {
      <ostso-filter-indicator [count]="filter.rateKindIds.length" label="Вид"/>
    }
    @if (filter.remarktype && !!filter.remarktype.length) {
      <ostso-filter-indicator [count]="filter.remarktype.length" label="Замечания"/>
    }
    @if (filter.remarkTypeIds && !!filter.remarkTypeIds.length) {
      <ostso-filter-indicator [count]="filter.remarkTypeIds.length" label="Замечания"/>
    }
    @if (filter.cost && filter.cost.from && filter.cost.from > 0 || filter.cost && filter.cost.to && filter.cost.to < 100) {
      <ostso-filter-indicator label="Стоимость"/>
    }
    @if (filter.IasId) {
      <ostso-filter-indicator label="ID ИАС Спорт"/>
    }
    @if (filter.Name) {
      <ostso-filter-indicator label="Наименование"/>
    }
    @if (filter.ManagerFioPart) {
      <ostso-filter-indicator label="Руководитель"/>
    }
    @if (filter.Ogrn) {
      <ostso-filter-indicator label="ОГРН"/>
    }
    @if (filter.StatusId && !!(+filter.StatusId)) {
      <ostso-filter-indicator label="Архив"/>
    }
    @if (filter.statusId && !!(+filter.statusId)) {
      <ostso-filter-indicator label="Архив"/>
    }
    @if (filter.statusIds && filter.statusIds.length) {
      <ostso-filter-indicator [count]="filter.statusIds.length" label="Архив"/>
    }
    @if (filter.archiveId && !!(+filter.archiveId)) {
      <ostso-filter-indicator label="Архив"/>
    }
    @if (filter.firmIds && filter.firmIds.length) {
      <ostso-filter-indicator [count]="filter.firmIds.length" label="Балансодержатель"/>
    }
    @if (filter.Address) {
      <ostso-filter-indicator label="Адрес"/>
    }
    @if (filter.DistrictIds && filter.DistrictIds.length) {
      <ostso-filter-indicator [count]="filter.DistrictIds.length" label="Округ"/>
    }
    @if (filter.RegionIds && filter.RegionIds.length) {
      <ostso-filter-indicator [count]="filter.RegionIds.length" label="Регион"/>
    }
    @if (filter.CadastralNumber) {
      <ostso-filter-indicator label="Кадастр"/>
    }
    @if (filter.isInvestmentObject!==undefined && filter.isInvestmentObject!==null) {
      <ostso-filter-indicator label="Объект ивестстроительства"/>
    }
    @if (filter.isLongspanStructureObject!==undefined && filter.isLongspanStructureObject!==null) {
      <ostso-filter-indicator label="Объект БПК"/>
    }
    @if (filter.facilityIds && filter.facilityIds.length) {
      <ostso-filter-indicator [count]="filter.facilityIds.length" label="Объект"/>
    }
    @if (filter.facilityTypeIds && filter.facilityTypeIds.length) {
      <ostso-filter-indicator [count]="filter.facilityTypeIds.length" label="Тип объекта"/>
    }
    @if (filter && filter.priorityIds && filter.priorityIds.length > 0) {
      <ostso-filter-indicator [count]="filter.priorityIds.length" label="Приоритет"/>
    }
    @if (filter && filter.facilityAddress) {
      <ostso-filter-indicator [count]="1" label="Адрес объекта"/>
    }
    @if (filter && filter.ids && filter.ids.length) {
      <ostso-filter-indicator [count]="filter.ids.length" label="ID"/>
    }
    @if (filter && filter.statusesIds && filter.statusesIds.length) {
      <ostso-filter-indicator [count]="filter.statusesIds.length" label="Статус"/>
    }
    @if (filter && filter.daysInWorkFrom) {
      <ostso-filter-indicator  label="Дней в работе от"/>
    }
    @if (filter && filter.daysInWorkTo) {
      <ostso-filter-indicator  label="Дней в работе до"/>
    }
    @if (filter && filter['dateTo']) {
      <ostso-filter-indicator  label="Дата проведения оценки до"/>
    }
    @if (filter && filter['dateFrom']) {
      <ostso-filter-indicator  label="Дата проведения оценки от"/>
    }
    @if (filter && filter.OperatorIds && filter.OperatorIds.length) {
      <ostso-filter-indicator [count]="filter.OperatorIds.length" label="Оператор"/>
    }
    @if (filter && filter.InspectorIds && filter.InspectorIds.length) {
      <ostso-filter-indicator [count]="filter.InspectorIds.length" label="Инспектор"/>
    }
    @if (filter && filter.indexEntityIds && filter.indexEntityIds.length) {
      <ostso-filter-indicator [count]="filter.indexEntityIds.length" label="Индекс"/>
    }
    @if (filter && filter.fillTypes && filter.fillTypes.length) {
      <ostso-filter-indicator [count]="filter.fillTypes.length" label="Способ заполнения"/>
    }
    @if (filter && filter.criterionIds && filter.criterionIds.length) {
      <ostso-filter-indicator [count]="filter.criterionIds.length" label="Критерий"/>
    }
    @if (filter && filter.periodIds && filter.periodIds.length) {
      <ostso-filter-indicator [count]="filter.periodIds.length" label="Тип оценки"/>
    }
    @if (filter && filter.periodId) {
      <ostso-filter-indicator  label="Тип оценки"/>
    }
    @if (filter && filter.cb && filter.cb.length) {
      <ostso-filter-indicator [count]="filter.cb.length" label="ЦБ"/>
    }
    @if (filter && filter.object && filter.object.length) {
      <ostso-filter-indicator [count]="filter.object.length" label="Объекты"/>
    }
    @if (filter && filter.implementerTypes && filter.implementerTypes.length) {
      <ostso-filter-indicator [count]="filter.implementerTypes.length"  label="Исполнитель"/>
    }
    @if (filter && filter.indicatorIds && filter.indicatorIds.length) {
      <ostso-filter-indicator [count]="filter.indicatorIds.length"  label="Показатель"/>
    }
    @if (filter && filter.organizationIds && filter.organizationIds.length) {
      <ostso-filter-indicator [count]="filter.organizationIds.length"  label="Учреждение"/>
    }
    @if (filter && filter.indexIds && filter.indexIds.length) {
      <ostso-filter-indicator [count]="filter.indexIds.length"  label="Индекс"/>
    }
    @if (filter && filter.departmentIds && filter.departmentIds.length) {
      <ostso-filter-indicator [count]="filter.departmentIds.length"  label="Подразделение"/>
    }
    @if (filter && filter.years && filter.years.length) {
      <ostso-filter-indicator [count]="filter.years.length"  label="Год"/>
    }
    @if (filter && filter.year ) {
      <ostso-filter-indicator  label="Год"/>
    }
    @if (filter && filter.quarters && filter.quarters.length) {
      <ostso-filter-indicator [count]="filter.quarters.length"  label="Квартал"/>
    }
    @if (filter && filter.quarter) {
      <ostso-filter-indicator  label="Квартал"/>
    }
    @if (filter && filter.groupIds && filter.groupIds.length) {
      <ostso-filter-indicator [count]="filter.groupIds.length"  label="Группа"/>
    }
    @if (filter && filter.objectGroupIds && filter.objectGroupIds.length) {
      <ostso-filter-indicator [count]="filter.objectGroupIds.length"  label="Группа объектов"/>
    }
    @if (filter && filter.organizationGroupIds && filter.organizationGroupIds.length) {
      <ostso-filter-indicator [count]="filter.organizationGroupIds.length"  label="Группа учреждений"/>
    }
    @if (filter && filter.indexIasValueIds && filter.indexIasValueIds.length) {
      <ostso-filter-indicator [count]="filter.indexIasValueIds.length"  label="Индекс ИАС"/>
    }
    @if (filter && filter.roleIds && filter.roleIds.length) {
      <ostso-filter-indicator [count]="filter.roleIds.length"  label="Роль"/>
    }
    @if (filter && filter.gradeStatusIds && filter.gradeStatusIds.length) {
      <ostso-filter-indicator [count]="filter.gradeStatusIds.length"  label="Статус оценки"/>
    }
    @if (filter && filter.executorType) {
      <ostso-filter-indicator  label="Исполнитель"/>
    }
    @if (filter && filter.cbTypeIds && filter.cbTypeIds.length) {
      <ostso-filter-indicator [count]="filter.cbTypeIds.length"  label="ЦБ"/>
    }
    @if (filter && filter.OrganizationGroupIds && filter.OrganizationGroupIds.length) {
      <ostso-filter-indicator [count]="filter.OrganizationGroupIds.length"  label="Группа учреждений"/>
    }
    @if (filter && filter.OrganizationIds && filter.OrganizationIds.length) {
      <ostso-filter-indicator [count]="filter.OrganizationIds.length"  label="Учреждения"/>
    }
    @if (filter && filter.OrgStatusIds && filter.OrgStatusIds.length) {
      <ostso-filter-indicator [count]="filter.OrgStatusIds.length"  label="Архив"/>
    }

  }
</div>
